import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { PublicPolicyView } from "@/components/policies/public-policy-view";

type PolicySearch = { p: string; lang: "ar" | "en" };

export const Route = createFileRoute("/policy/")({
  validateSearch: (search: Record<string, unknown>): PolicySearch => ({
    p: typeof search.p === "string" ? search.p : "",
    lang: search.lang === "en" ? "en" : "ar",
  }),
  component: PolicyQueryPage,
});

function PolicyQueryPage() {
  const { p, lang } = Route.useSearch();
  const navigate = useNavigate();

  return (
    <PublicPolicyView
      slug={p}
      lang={lang}
      onLang={(next) => {
        void navigate({ to: "/policy", search: { p, lang: next } });
      }}
    />
  );
}
